import React from "react";
import PagesBanner from "./PagesBanner";
import Menu from "../Food Menu/Menu";

const MenuPage = () => {
  return <>
    <PagesBanner title={'Food Menu'} />
    <Menu />
  </>;
};

export default MenuPage;
